// extracted by mini-css-extract-plugin
module.exports = {"SectionFooterSeparator":"SectionFooterSeparator_SectionFooterSeparator__u09WI"};